import ListItem from '../shared/List/ListItem';
import CardThumbnail from '../shared/CardThumbnail/CardThumbnail';
import { DeeplinkEvent } from '../../sdk/deeplink.event';
import NavigationUtils from '../../utils/navigation.utils';
import FormatterUtils from '../../utils/formatter.utils';
import { _className } from '../../utils/classname.utils';
import style from './SendMoneyOption.css';
import React from 'preact/compat';
import CardStatus from '../../constants/card.status';
import CaasStorageKeys from '../../constants/caas.storage.keys';
import { EnterAmountType } from '../../routes/EnterAmountPage/EnterAmountProvider';

export default function SendMoneyOption({
  card,
  onCardClick,
  t,
  config,
  getOrganization,
  getCurrency,
}) {
  return (
    <div className={style.container}>
      <ListItem
        testData={{
          itemTestId: 'card',
          titleTestId: 'card-organization',
          iconTestId: 'card-icon',
        }}
        icon={
          <CardThumbnail
            className={style.cardIcon}
            organization={card.organizationCode}
          />
        }
        key={card.uid}
        infoText={card.status === CardStatus.ACTIVE ? undefined : t('Locked')}
        infoTextClassName={style.cardStatusLocked}
        title={t('{company_name} to Contact', {
          '{company_name}': getOrganization(card.organizationCode),
        })}
        subtitle={
          <span
            className={_className(
              !config[CaasStorageKeys.STORAGE].showBalance,
              'text-blur',
            )}
            data-testid="card-balance"
          >
            {FormatterUtils.currency(card.balance, getCurrency(card.currency))
              .split(' ')
              .map(el => (
                <span> {el}</span>
              ))}
          </span>
        }
        actionable={true}
        onClick={() => {
          if (card.status === CardStatus.LOCKED) {
            onCardClick(card, true);
            return;
          }

          onCardClick(card, false);
          DeeplinkEvent.openWebview(
            `${NavigationUtils.Routes.P2P_CONTACT_LIST.replace(
              ':cardUid',
              card.uid,
            )}?source=${NavigationUtils.Sources.HOME}&organization=${
              card.organizationCode
            }&type=card`,
          );
        }}
      />

      {card.sendMoneyCompanyEnabled && (
        <ListItem
          testData={{
            itemTestId: 'card',
            titleTestId: 'card-organization',
            iconTestId: 'card-icon',
          }}
          className={`${style.companyOption}`}
          title={t('To {company_name} Company', {
            '{company_name}': getOrganization(card.organizationCode),
          })}
          icon={
            <CardThumbnail
              className={style.cardIcon}
              organization={card.organizationCode}
            />
          }
          subtitle={
            <span
              className={_className(
                !config[CaasStorageKeys.STORAGE].showBalance,
                'text-blur',
              )}
              data-testid="card-balance"
            >
              {FormatterUtils.currency(card.balance, getCurrency(card.currency))
                .split(' ')
                .map(el => (
                  <span> {el}</span>
                ))}
            </span>
          }
          actionable={true}
          onClick={() => {
            if (card.status === CardStatus.LOCKED) {
              onCardClick(card, true);
              return;
            }
            DeeplinkEvent.openWebview(
              `${NavigationUtils.Routes.ENTER_AMOUNT}?organizationCode=${card.organizationCode}&type=${EnterAmountType.SEND_MONEY_TO_COMPANY}&source=${NavigationUtils.Sources.HOME}`,
            );
          }}
        />
      )}
    </div>
  );
}
